module.exports = __webpack_public_path__ + "img/safe_tool_8.ca48e817.jpg";